module.exports = __webpack_public_path__ + "static/media/activity-icon.6dc25240.svg";